import React from 'react';
import styled from 'styled-components';
import { Spring, animated } from 'react-spring';
import { lightGrey3Color } from 'js/config/style';

const Container = animated(styled.div`
  color: ${lightGrey3Color};
  text-align: right;
  font-size: 0.8rem;
`);

export default props => (
  <Spring
    native
    from={{ opacity: 0, transform: 'translate3d(0,-1rem,0)', position: 'relative' }}
    to={{ opacity: 1, transform: 'translate3d(0,0rem,0)' }}
    config={{ delay: 200 }}>
    {animation => <Container style={animation} {...props} />}
  </Spring>
);
